<template>
  <v-list>
    <v-list-item
      v-for="(item, i) in items"
      :key="i"
      :to="item.to"
      active-class="default-class active"
    >
      <v-list-item-action>
        <v-icon>{{ item.icon }}</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: "MainMenu",
  methods: {
    menuRoutes(routes) {
      routes = routes || this.$router.options.routes;
      const r = routes
        .filter(route => route.meta && route.meta.mainMenu)
        .concat(
          ...routes
            .filter(route => route.children)
            .map(route => {
              return this.menuRoutes(route.children);
            })
        );
      return r;
    }
  },
  computed: {
    user() {
      return this.$store.getters["auth/getUser"];
    },
    items() {
      return this.menuRoutes()
        .sort((a, b) => a.meta.mainMenu - b.meta.mainMenu)
        .filter(route => this.user && this.user.hasRouteAccess(route))
        .map(route => {
          return {
            to: { name: route.name, params: { invalidate: true } },
            title: route.meta.title,
            icon: route.meta.icon
          };
        });
    }
  }
};
</script>
<style scoped>
.active {
  color: white;
  opacity: 0.5;
}
</style>
